function getCommandMatches(command: string, commandMatchRegularExpressions: RegExp[]): string[] {
  const commandMatches: string[] = [];
  commandMatchRegularExpressions.forEach((regExp) => {
    let matches: RegExpExecArray = regExp.exec(command);
    while (matches != null) {
      commandMatches.push(...matches);
      matches = regExp.global ? regExp.exec(command) : null;
    }
  });
  return commandMatches;
}

export { getCommandMatches };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/handlers/helper.ts